import React from 'react';
import { randomString } from 'helpers/string';
import LiveAuctionSearchPage from 'components/Auctions/LiveAuctionSearchPage';

const OnlineSearch = () => {
    return (
        <LiveAuctionSearchPage />
    );
};

OnlineSearch.getInitialProps = async ({store: { dispatch }, query})  => {
    const pageData = {
        title: 'Live Storage Auctions', 
        marginBottom: 'pageTitle marginB20', 
        h1: 'Live Storage Auctions',
        description: undefined,
    };
    const rand_str = randomString();

    return { query, rand_str, pageData };
};


export default OnlineSearch;